import Swiper, { Navigation, EffectCards } from 'swiper';

function achievementsChoicer() {
  const entity = document.querySelectorAll('.js-achievements-choicer');
  if (!entity) return;

  const sliders = [];

  entity.forEach((elem) => {
    const nextButton = elem.querySelector('.swiper-button-next');
    const prevButton = elem.querySelector('.swiper-button-prev');
    const swiper = new Swiper(elem, {
      modules: [EffectCards, Navigation],
      effect: 'cards',
      cardsEffect: {
        rotate: true,
      },
      grabCursor: true,
      initialSlide: 0,
      speed: 500,
      loop: true,
      mousewheel: {
        invert: false,
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      on: {
        init: function () {
          this.el.classList.remove('swiper');
        },
      },
    });

    return sliders.push(swiper) // eslint-disable-line
  });

  return { // eslint-disable-line
    sliders,
  };
}

export default achievementsChoicer;
